<template>
	<div style="position: relative;">
		<!--<input type="" name="" id="" value=""  />-->
		<div class="search-box f-cb" style="max-width: 600px;">
			<span class="tit f-fl"> MA.</span>
			<div class="f-fr" style="width: 87%;">
				<el-input v-model.trim="name" @keyup.enter.native="inquire" placeholder="请输入内容" clearable>
					<div slot="append">
						<el-button type="primary" @click="inquire" style="background-color: #1b59a8;color: white;border-bottom-left-radius: 0;border-top-left-radius: 0;">
							<i class="el-icon-search"></i> 查询
						</el-button>
					</div>

				</el-input>
				<p style="text-align: left;margin-top: 15px;font-size: 13px;">
					<!--温馨提示：支持中文、英文字母、数字或三者任意组合，长度须至少{{parseInt(size)+1}}个字符！(一个中文为2个字符，一个英文字母或一个数字为1个字符）-->
					温馨提示：支持中文、英文字母或中文、英文字母、数字三者任意组合（暂不支持纯数字），长度须至少{{parseInt(size)+1}}个字符！(一个中文为2个字符，一个英文字母或一个数字为1个字符）
				</p>
			</div>

			<div></div>
		</div>
		<transition name="el-fade-in-linear">
			<div v-show="may">
				<div class="context-box">
					<h1 class="tit"> 码标查询结果 </h1>
					<div class="message f-cd" style="color: #67c23a;">

						<span class="f-fl ego" style="color: #333;">
					MA.{{name}}
				</span>
						<span style="display: inline-block;margin: 0 auto;" class="ego">
								{{informData.register}}
							</span>
						<div class="f-fr" style="display: inline-block;padding: 0;">

							<el-button type="text" v-if="informData.price===''" @click="dialogVisible = true">查看详情</el-button>
							<!-- <span v-html="informData.price" class="ego" style="color: #f56c6c;" v-else> </span> -->
						</div>

					</div>

				</div>
				<!--{{agreementisible}}-->
				<div style="text-align: left;">
					<p style="text-align: center;font-size: 14px;padding: 20px 0; color: #333;">{{hinttit }} </p>
					<div class="purchase-box" v-show="purchase">
						<el-checkbox v-model="checked"> </el-checkbox> <span style="font-size: 14px;cursor: pointer;" @click="syncmutated = true">我已阅读并同意码标用户注册解析服务协议</span>
						<div style="margin-top: 50px;">
							<el-button type="primary" @click="nextstep ">注册</el-button>
						</div>

					</div>
				</div>

			</div>

		</transition>
		<img src="../assets/imgs/01.png" style="position: absolute; right: 9%;display: inline-block;top: 100px;" />
		<el-dialog :title="name+' 详情'" :visible.sync="dialogVisible" width="840px">
			<!--<div>-->
			<div class="Madata-box">
				<h1 class="Matit"> 码标注册信息</h1>
				<ul class="MadataU f-cb">
					<li class="MadataL f-fl" v-for="(item,index) in dataone" v-if="item.context!=''" :key="index">
						<span class="tit">{{item.title}}：</span>
						<span class="contex">{{item.context}}</span>
					</li>
				</ul>
			</div>
			<!--{{datatwo}}-->
			<div class="Madata-box" v-if="false">
				<h1 class="Matit">所属单位信息 </h1>
				<ul class="MadataU f-cb">
					<li class="MadataL f-fl" v-for="(item,index) in datatwo" v-if="item.context!=''" :key="index">
						<span class="tit">{{item.title}}：</span>
						<span class="contex">{{item.context}}</span>
					</li>
				</ul>
			</div>
		</el-dialog>

		<el-dialog title="码标用户注册解析服务协议" :visible.sync="syncmutated" width="40%" custom-class="dialog-box">
			<codedialog :sync="agreementisible"></codedialog>
			<span slot="footer" class="dialog-footer">
    <el-button @click="syncmutated = false">取 消</el-button>
    <el-button type="primary" @click="syncmutated = false">确 定</el-button>
  </span>
		</el-dialog>

	</div>
</template>

<script>
//	import once from "lodash/once";
	import codedialog from '@/components/CodeDialog';
	import debounce from "lodash/debounce";
	export default {
		components: {
			codedialog
		},
		data() {
			return {
				syncmutated: false,
				agreementisible: false,
				dialogVisible: false,
				may: false,
				purchase: false,
				name: '',
				informData: {
					register: '',
					price: '',
				},
				hinttit: '',
				checked: true,
				tableData: [],
				dataone: [{
						title: '码标',
						context: ''
					},
					//					{
					//						title: '码标状态',
					//						context: ''
					//					},
					{
						title: '注册时间',
						context: ''
					},
					{
						title: '到期时间',
						context: ''
					},
					{
						title: '所属注册服务商',
						context: ''
					}

				],
				datatwoShow: false,
				datatwo: [{
						title: '单位名称',
						context: ''
					},
					{
						title: '单位主码',
						context: ''
					},
					{
						title: '单位地址',
						context: ''
					},
					{
						title: '联系人',
						context: ''
					},
					{
						title: '联系电话',
						context: ''
					},
					{
						title: '手机',
						context: ''
					},

				],
				size: 0,
			}
		},
		created() {
			//          let than =this; 
			//	   	 let sizeAstrict= once(function(){
			//	   	 	console.log(than.$api)
			//				than.$http.get(than.$api + '/baseData/getIdentificationRegNum', {}).then(res => {
			//				
			//					if(res.body.result === 1) {
			//						than.size = res.body.entity.num;
			//					}
			//				})
			//			})
			//	   	 sizeAstrict();

			this.$http.get(this.$api + '/baseData/getIdentificationRegNum', {}).then(res => {

				if(res.body.result === 1) {

					this.size = res.body.entity.num;
				}
			})
		},
		methods: {
			//计算字符长度
			strlen(str) {
				var len = 0;
				for(var i = 0; i < str.length; i++) {
					var c = str.charCodeAt(i);
					//单字节加1   
					if((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
						len++;
					} else {
						len += 2;
					}
				}
				return len;
			},
			inquire: debounce(function() {
				let {
					name: MaName
				} = this
				if(this.name != '') {
					if(this.strlen(this.name) > this.size) {

						if(MaName != 'excel' && !/^\d{1,}$/g.test(MaName) && (/^[a-zA-Z]+$/g.test(MaName) || /^[a-zA-Z0-9]+$/g.test(MaName) || /^[\u4e00-\u9fa5a-zA-Z0-9]+$/g.test(MaName))) {
							this.$http.get(this.$api + '/identificationApply/searchIdentification', {
								params: {
									identification: 'MA.' + this.name,
									//									domain: this.$store.state.commonalityData.official
								}
							}).then(res => {
								this.informData.price = "";
								this.informData.register = res.body.result === 0 ? '已注册' : '未注册';
								if(res.body.result === 0) {
									this.purchase = false;
									this.may = true;

									let {
										identificationInfo,
										organUnit
									} = res.body.entity;

									['identification', 'createDate', 'endYear', 'agent_Name'].forEach((item, index) => {

										this.dataone[index].context = identificationInfo[item]
									})
									//										this.dataone[0].context = identificationInfo.identification;
									//										this.dataone[2].context = identificationInfo.createDate;
									//										this.dataone[3].context = identificationInfo.endYear;
									//										this.dataone[4].context = identificationInfo.name;
									if(organUnit === null || organUnit === "") {
										this.datatwoShow = false;
									} else {
										this.datatwoShow = true;
										this.datatwo[0].context = organUnit.organunitname;
										this.datatwo[1].context = identificationInfo.analyIDcode;
										this.datatwo[2].context = organUnit.organunitaddress;
										this.datatwo[3].context = organUnit.linkman;
										this.datatwo[4].context = organUnit.fax;
										this.datatwo[5].context = organUnit.linkphone;
									}

								} else if(res.body.result === 1) {
									this.purchase = true;
									this.may = true;

									this.informData.price = res.body.entity.price
								} else if(res.body.result === 2) {
									this.$alert(res.body.message, '提示', {
										confirmButtonText: '确定',
										//										showCancelButton: true,
										//										cancelButtonText: '放弃注册',
										dangerouslyUseHTMLString: true,
										//										callback: action => {
										//											if(action === 'confirm') {
										//												this.$router.push({
										//													path: 'renew',
										//													query: {
										//														name: 'MA.' + this.name,
										//														type: 1,
										//													}
										//												})
										//											} else {
										//
										//											}
										//										}
									});

									this.informData.price = res.body.entity.price
								} else if(res.body.result === 3) {
									this.$alert(res.body.message, '提示', {
										confirmButtonText: '继续注册',
										showCancelButton: true,
										cancelButtonText: '放弃注册',
										dangerouslyUseHTMLString: true,
										callback: action => {
											if(action === 'confirm') {
												this.$router.push({
													path: 'continueexplain',
													query: {
														name: escape('MA.' + this.name),
														price: escape(res.body.entity.price)
													}
												})
											} else {
												//												this.$router.push({
												//													path: 'home'
												//												})

											}
											//											window.location.href = "../index.html";

										}
									});

								} else {
									this.may = false;
									this.$message.error(res.body.message);
								}
								//					this.may = true;
							}, ()=>{
								this.$message.error('数据获取失败');
							})
						} else {
							this.$message.error('输入码标格式不正确，请重新输入!');

						}
					} else {
						this.$message.error(`您输入的码标少于${parseInt(this.size)+1}个字符，请重新输入！(一个中文为2个字符，一个英文字母或一个数字为1个字符）`);

					}
				} else {
					this.$message.error('查询码标不能为空!');

				}

			}, 300),
			nextstep() {

				//				if(){
				//					
				//				}
				if(this.checked) {
					this.$router.push({
						path: 'renew',
						query: {
							name: 'MA.' + this.name,
							type: 1,
						}
					})

				} else {
					this.$message.error('请先勾选《我已阅读并同意码标注册协议》');

				}

			},
		},
		watch: {
			name: function() {
				this.may = false;
			},
		}

	}
</script>

<style lang="scss">
	@import "@/assets/css/whole.scss";
	.search-box {
		width: 50%;
		min-width: 390px;
		/*border: solid red 1px;*/
		/*margin: 0 auto;*/
		margin-left: 180px;
		padding-top: 100px;
		.tit {
			/*font-size: 20px;*/
			line-height: 40px;
			/*margin-right: 10px;*/
			font-size: 24px;
			font-weight: 800;
			color: #1b59a8;
		}
	}
	
	.context-box {
		width: 50%;
		/*border: solid red 1px;*/
		margin-left: 180px;
		/*margin: 0 auto;*/
		/*margin-top: 20px;*/
		.tit {
			/*width: 812px;*/
			font-size: 17px;
			color: #333333;
			margin: 0 auto;
			margin-top: 0px;
			margin-top: 82px;
			padding-bottom: 24px;
		}
		.message {
			/*border-top: solid #e8e8e8 1px;*/
			/*border: solid red 1px;*/
			min-height: 100px;
			/*position: relative;*/
			/*padding-top: 20px;*/
			.ego {
				padding: 10px 0;
				/*border: solid red 1px;*/
				font-size: 14px;
				display: inline-block;
			}
		}
	}
	
	.purchase-box {
		padding: 50px 0;
		width: 50%;
		/*text-align: left;*/
		margin-left: 170px;
		text-align: center;
		display: inline-block;
	}
	
	.Madata-box {
		width: 100%;
		border-left: solid #dfdfdf 1px;
		border-right: solid #dfdfdf 1px;
		border-bottom: solid #dfdfdf 1px;
		margin-bottom: 20px;
		.MadataU {
			padding-bottom: 20px;
			.MadataL {
				width: 50%;
				padding: 14px 0;
				/*overflow: hidden;*/
				display: inline-block;
				.tit {
					font-size: 14px;
					display: inline-block;
					color: #333;
				}
				/*border: solid red 1px;*/
				.contex {
					/*width: 40px;*/
					max-width: 300px;
					display: inline-block;
					overflow: hidden;
					vertical-align: bottom;
					margin: 0;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
		.Matit {
			text-align: left;
			background-color: #f9f9f9;
			font-size: 15px;
			color: #333;
			border-top: solid $theme-color 2px;
			font-weight: 500;
			padding: 12px 0 12px 40px;
		}
	}
</style>